import { computed } from 'vue'

import { socketService } from '../services/socket.service'

import type { SocketConnectionConfig } from '../services/socket.service'

export const useSockets = () => {
  const connect = (config: SocketConnectionConfig) => socketService.connect(config)
  const disconnect = () => socketService.disconnect()
  const on = <T = unknown>(event: string, handler: (payload: T) => void) =>
    socketService.on(event, handler)
  const off = <T = unknown>(event: string, handler?: (payload: T) => void) =>
    socketService.off(event, handler)
  const emit = (
    event: string,
    payload: unknown,
    options?: { queueIfDisconnected?: boolean; dedupeKey?: string }
  ) => socketService.emit(event, payload, options)

  return {
    connect,
    disconnect,
    on,
    off,
    emit,
    socket: computed(() => socketService.socket.value),
    isConnected: computed(() => socketService.connected.value),
  }
}
